<template>
    <div id="BlockTitle">
        <div class="block-title-container">
            <input :placeholder="$t('chatbotv2.typeBlockTitle')" v-model="blockName" />
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
    name: "BlockTitle",
    props: ["name", "block", "isSave"],
    data() {
        return {
            blockName: this.name,
        };
    },
    methods: {
        ...mapActions({
            updateBlock: "automation/updateBlock",
        }),
        async updateName() {
            await this.updateBlock({
                blockId: this.block.id,
                payload: {
                    name: this.blockName.trim(),
                },
            });
            this.$toasted.success(this.$t("chatbotv2.blockUpdated"), {
                duration: 2000,
                position: "bottom-center",
            });
        },
    },
    beforeDestroy() {
        if (this.isSave && this.name != this.blockName) {
            this.updateName();
        }
    },
};
</script>

<style lang="scss">
#BlockTitle {
    .block-title-container {
        input {
            border: 0;
            font-size: 22px;
            font-weight: 600;
            line-height: 28px;
            width: 100%;
            font-family: Source Sans Pro, sans-serif;
        }
    }
}
</style>
